import {
  Autocomplete,
  Box,
  Button,
  Fade,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import TotalChart from "../TotalChart";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import useChartCustomerLogic from "./useChartCustomerLogic";
import TabChartFilter from "../components/TabChartFilter";
import Layout from "../components/Layout";
import BuutonFilter from "../components/BuutonFilter";
import SwitchButton from "../components/SwitchButton";
import RenderDatePicker from "../components/RenderDatePicker";
import { useDashboardSettings } from "../../../../Context/DashboardSettingProvider";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { FilterIcon } from "lucide-react";
import CustomerBarChart from "./ChartRenderer";
import { useGetCustomerReceivedFileTypeDropdown } from "../Hook";
import FilterHandler from "../components/FilterHandler";
function DesignerTimeDesign() {
  const theme = useTheme().palette.mode;
  const { action, data } = useChartCustomerLogic();
  const {
    countState,
    orderType,
    activeFilterType,
    chartFilter,
    setReceivedFileTypeId,
  } = data;
  const { changeActiveFilterType, tabHandler } = action;
  const { data: getCustomerReceived } =
    useGetCustomerReceivedFileTypeDropdown();
  const deviceType = useDeviceType();
  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "designerTimeChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  const [value, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  return (
    <Box>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                padding: "0.5rem",
              }}
            >
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"مجموع ساعات"}
                type={1}
                activeFilterType={activeFilterType}
              />
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"میانگین ساعات"}
                type={2}
                activeFilterType={activeFilterType}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "40%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"مدت زمان طراحی (طراح)"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                {/* Filter By Date */}
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                />
              </Box>
              <Box sx={{ placeSelf: "end" }}>
                <FilterHandler filter={filter} setFilter={setFilter} />
              </Box>
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  display: "flex",
                  marginTop: "10px",
                  marginBottom: "10px",
                  padding: "8px",
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <RenderDatePicker
                  chartFilter={chartFilter}
                  datePicker={data.datePicker}
                  setDatePicker={action.setDatePicker}
                />
              </Box>
            </Fade>
          )}

          <CustomerBarChart data={countState} type={activeFilterType} />
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            minWidth: 200,
          }}
        >
          <TitleChart label={"مدت زمان طراحی (طراح)"} chartKey={chartKey} />
        </Box>
      )}
    </Box>
  );
}

export default DesignerTimeDesign;
